import { useContext, useMemo } from 'react';
import ProfileList from '../common/ProfileList';
import { TEXTS } from '../../../../core/texts';
import EducationListItem, { EDUCATION_QUERY_PARAM } from './EducationListItem';
import { FreelancerContext } from '../FreelancerEntity';
import ExperienceOrEducationEntityModal
  from '../common/ExperienceOrEducationEntityModal/ExperienceOrEducationEntityModal';

const EducationList = () => {
  const { user } = useContext(FreelancerContext);
  const educationList = useMemo(() => user.freelancerProfile.educations || [], [user]);
  return (
    <ProfileList
      list={educationList}
      title={TEXTS.EDUCATION}
      emptyListText={TEXTS.NOT_ADDED}
      ListItemComponent={EducationListItem}
      entityQueryParam={EDUCATION_QUERY_PARAM}
      EntityComponent={ExperienceOrEducationEntityModal}
    />
  );
};


export default EducationList;